import React from 'react';
import video1 from '../assets/videos/1.mp4';
const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="inicio">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-tag">Primera Plataforma GDPR-Nativa de Europa</div>
          <h1 className="hero-title">
            <span>Transforma la</span>
            <span className="gradient-text">Experiencia</span>
            <span>de tus Clientes</span>
          </h1>
          <p className="hero-description">
            Revolucionamos la atención al cliente con avatares inteligentes que hablan, 
            entienden y responden como humanos. IA conversacional avanzada para retail, 
            hostelería y turismo.
          </p>
          <div className="hero-cta">
            <button className="btn btn-primary" onClick={() => scrollToSection('contacto')}>
              Solicita una Demo
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection('casos')}>
              Ver Casos de Uso
            </button>
          </div>
        </div>
        <div className="hero-video-container">
          <div className="hero-video-box">
            <video 
              className="hero-video" 
              controls 
              poster=""
              preload="metadata"
              src={video1}
            >
              <source src="/videos/1.mp4" type="video/mp4" />
              Tu navegador no soporta el elemento de video.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
